import React from 'react'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { filterExists } from '~/utils'

const document = graphql(`
  query AiUsageExportPage_Main($month: String!) {
    analyzerAiUsage(month: $month) {
      date
      brandAccountId
      origin
      model
      calls
      promptTokens
      outputTokens
      cachedTokens
      thoughtsTokens
    }
    overallAiUsage(month: $month) {
      date
      brandAccountId
      origin
      model
      calls
      promptTokens
      outputTokens
      cachedTokens
      thoughtsTokens
    }
    brandAccounts {
      id
      name
    }
  }
`)

export const useAiUsageQuery = () => {
  const graphQLRequest = useGraphQLRequest()

  return React.useCallback(
    async (month: string) => {
      const result = await graphQLRequest({ document, variables: { month } })

      return {
        analyzerAiUsage: filterExists(result.analyzerAiUsage),
        brandAccounts: filterExists(result.brandAccounts),
        overallAiUsage: filterExists(result.overallAiUsage),
      }
    },
    [graphQLRequest],
  )
}
